import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

let push = null;

export function showToast(message, opts) {
  if (push) push(message, opts);
}

export function ToastHost() {
  const [items, setItems] = useState([]);
  const idRef = useRef(0);

  useEffect(() => {
    push = (message, opts = {}) => {
      const id = ++idRef.current;
      const kind = opts.kind || 'info';
      const duration = opts.duration ?? 2200;
      setItems((prev) => [...prev, { id, message, kind }]);
      setTimeout(() => {
        setItems((prev) => prev.filter((t) => t.id !== id));
      }, duration);
    };
    return () => { push = null; };
  }, []);

  if (typeof document === 'undefined') return null;
  return createPortal(
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        zIndex: 9999,
        pointerEvents: 'none',
      }}
    >
      {items.map((t) => (
        <div
          key={t.id}
          style={{
            pointerEvents: 'auto',
            background: t.kind === 'error' ? '#dc2626' : '#111827',
            color: '#fff',
            padding: '10px 14px',
            borderRadius: 8,
            fontSize: 14,
            boxShadow: '0 10px 25px rgba(0,0,0,0.18)',
            animation: 'zw-toast-in 140ms ease-out',
            maxWidth: 360,
          }}
        >
          {t.message}
        </div>
      ))}
      <style>{`@keyframes zw-toast-in {
        from { opacity: 0; transform: translateY(8px); }
        to   { opacity: 1; transform: translateY(0); }
      }`}</style>
    </div>,
    document.body
  );
}
